const getSafePlugin = {
	install(Vue) {
		Vue.prototype.$getSafe = function (fn) {
			try {
				return fn();
			} catch (e) {
				return null;
			}
		};
	}
};

export default getSafePlugin;
